import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TransferIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M5.01611 14.7278L6.68011 9.38378H3.01611L2.00811 10.7278H1.01611L1.67211 8.39178L1.01611 6.07178H2.00811L3.01611 7.38378H6.68011L5.01611 2.07178H6.32811L9.67211 7.38378H13.3361C13.6131 7.38378 13.8481 7.47978 14.0401 7.67178C14.1347 7.76578 14.2091 7.87815 14.2586 8.00198C14.3081 8.12581 14.3318 8.25846 14.3281 8.39178C14.3308 8.5228 14.307 8.65301 14.2582 8.7746C14.2093 8.89619 14.1363 9.00663 14.0436 9.0993C13.951 9.19196 13.8405 9.26493 13.7189 9.31382C13.5973 9.36271 13.4671 9.3865 13.3361 9.38378H9.67211L6.32811 14.7278H5.01611ZM18.3281 10.0718L16.6641 15.4158H20.3281L21.3361 14.0718H22.3281L21.6721 16.4078L22.3281 18.7278H21.3361L20.3281 17.4158H16.6641L18.3281 22.7278H17.0161L13.6721 17.4158H10.0081C9.87732 17.4184 9.74738 17.3942 9.62631 17.3446C9.50523 17.2951 9.39558 17.2213 9.30411 17.1278C9.20951 17.0338 9.13515 16.9214 9.08562 16.7976C9.03609 16.6737 9.01243 16.5411 9.01611 16.4078C9.01339 16.2768 9.03719 16.1465 9.08607 16.025C9.13496 15.9034 9.20793 15.7929 9.3006 15.7003C9.39326 15.6076 9.50371 15.5346 9.62529 15.4857C9.74688 15.4368 9.8771 15.4131 10.0081 15.4158H13.6721L17.0161 10.0718H18.3281Z'
                fill='currentColor'
            />
        </>
    ),
})

TransferIcon.displayName = 'TransferIcon'
